import React, { useState, useRef } from "react";
import { BartRoutes } from "src/routing/bartRoutes";
import { InitDomain } from "../context/domain/domainContext";
import { Domain } from "src/config/BartLambdaConfig";
import { configureDomain } from "src/auth/config";
import { FullPageHeader } from "src/components/header/header";
import { AuthService } from "src/auth/auth-service";
export const RouteMap = () => {
  const [domain, setDomain] = useState<Domain>(configureDomain);

  // Lazy initialization of AuthService - only create once
  const authServiceRef = useRef<AuthService | null>(null);
  const getAuthService = (): AuthService => {
    if (!authServiceRef.current) {
      authServiceRef.current = new AuthService();
    }
    return authServiceRef.current;
  };

  return (
    <InitDomain.Provider
      value={{
        domain,
        setDomain,
        authService: getAuthService(),
      }}
    >
      <FullPageHeader />
      <BartRoutes domain={domain} />
    </InitDomain.Provider>
  );
};
